import React,{useState, useEffect}  from 'react'
import { Container, Button, Row, Col, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Message } from 'primereact/message';
import api from '../../../../interceptor/axios';

const SignUp = (props) => {
    const [validando, setValidando] = useState(false);
    const [labelBoton, setLabelBoton] = useState('Registrarse');
    const [error, setError] = useState('');
    const [nick, setNick] = useState('');
    const [email, setEmail] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [dni, setDni] = useState('');
    const [telefono, setTelefono] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    const esDNIValido = (dni) => {
        //esta funcion valida si el DNI es valido y veridico
        //pasamos a mayusculas
        dni = dni.toUpperCase();
        const regex = /^[0-9]{8}[A-Z]$/;
        const regexNIE = /^[XYZ][0-9]{7}[A-Z]$/
        if (!regex.test(dni) && !regexNIE.test(dni)) {
            return false;
        }
        const dniLetter = dni.slice(-1);
        const dniNumber = dni.slice(0, -1);
        const nieLetter = dni[0];
        const nieNumber = dni.slice(1, -1);
        const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        let validDni = false;
        let validNie = false;
        if (regex.test(dni)) {
            const index = dniNumber % 23;
            validDni = dniLetter === letters[index];
        } else if (regexNIE.test(dni)) {
            const nieIndex = 'XYZ'.indexOf(nieLetter);
            const index = (nieIndex * 10000000 + parseInt(nieNumber)) % 23;
            validNie = dniLetter === letters[index];
        }
        return validDni || validNie;
    };


    const validar = () => {
        //validamos todos los campos
        if(!nick || !email || !nombre || !apellidos || !dni || !telefono || !password || !password2){
            setError('Por favor, rellene todos los campos');
        } else {
            //comprobamos que las dos contraseñas coincidan
            if(password !== password2){
                setError('Las contraseñas no coinciden');
            } else {
                if(!esDNIValido(dni)){
                    setError('El DNI/NIE no es válido');
                } else {
                    //ademas comprobamos que el dni o nie sea veridico
                    const dniLetter = dni.slice(-1);
                    const dniNumber = dni.slice(0, -1);
                    const nieLetter = dni[0];
                    const nieNumber = dni.slice(1, -1);
                    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
                    let validDni = false;
                    let validNie = false;   

                    //comprobamos que el telefono sea valido
                    const regexTelefono = /^[0-9]{9}$/;
                    if(!regexTelefono.test(telefono)){
                        setError('El teléfono no es válido');
                    } else {
                        //comprobamos que el email sea valido
                        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if(!regexEmail.test(email)){
                            setError('El email no es válido');
                        } else {
                            //comprobamos que la contraseña sea valida tiene que cumplir los siguientes criterios:
                            // - Debe tener entre 8 y 16 caracteres
                            // - Debe contener al menos una letra mayúscula
                            // - Debe contener al menos una letra minúscula
                            // - Debe contener al menos un número
                            // - Debe contener al menos un carácter especial: @-_$#*:.
                            const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@\-_$#*])[A-Za-z\d@\-_$#*:.]{8,16}$/;                                                   

                            if(!regexPassword.test(password)){
                                setError('La contraseña no es válida');
                            } else {

                                //comprobamos que el nick no tenga espacios en blanco
                                const regexNick = /^[^\s]+$/;
                                if(!regexNick.test(nick)){
                                    setError('El nick no puede contener espacios en blanco');
                                } else {
                                    setError('');
                                    setValidando(true);
                                    setLabelBoton('VALIDANDO...');

                                    api
                                    .post(process.env.REACT_APP_REST_URL + 'registro.php', { 
                                        nick: nick,                                    
                                        email: email, 
                                        nombre: nombre,
                                        apellidos: apellidos,
                                        dni: dni, 
                                        telefono: telefono,
                                        password: password })
                                    .then(response => {
                                        if (response.data.success) {
                                            alert('El registro se ha realizado correctamente. A continuación serás redirigido a la pagina de login y podrás entrar');
                                            window.location.href = '/login';
                                        } else {
                                            setError(response.data.message);
                                            setValidando(false);
                                            setLabelBoton('Registrarse'); 
                                        }
                                    })
                                    .catch(error => {
                                        setError(error.message);
                                    });
                                }
                            }                                
                        }
                    }
                }
            }
        }
    };


    return (
        <>

            <section className="sign-in-page">
                <Container>
                    <Row className="justify-content-center align-items-center height-self-center">
                        <Col lg="7" md="12" className="align-self-center">
                            <div className="sign-user_card ">                    
                                <div className="sign-in-page-data">
                                    <div className="sign-in-from w-100 m-auto">
                                        <Form>
                                            <Row>
                                                <Col md="12">
                                                    <p>Para registrarse es necesario previamente haber contactado con la administración del centro. Si aún no lo has hecho, puedes hacerlo por teléfono o whatsapp en el siguiente número:</p>
                                                    <h5>671 54 03 66</h5>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Nick</Form.Label>
                                                        <Form.Control disabled={validando} value={nick} onChange={(e) => setNick(e.target.value)} type="text" className="form-control mb-0" id="exampleInputEmail2" placeholder="Introduce tu nick" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>  
                                                        <Form.Label>E-mail</Form.Label>                               
                                                        <Form.Control disabled={validando} value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="mb-0" id="exampleInputEmail3" placeholder="Introduce tu email" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Nombre</Form.Label>
                                                        <Form.Control disabled={validando} value={nombre} onChange={(e) => setNombre(e.target.value)} type="text" className="mb-0" id="exampleInputEmail2" placeholder="Introduce tu nombre" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>  
                                                        <Form.Label>Apellidos</Form.Label>                               
                                                        <Form.Control disabled={validando} value={apellidos} onChange={(e) => setApellidos(e.target.value)} type="text" className="mb-0" id="exampleInputEmail3" placeholder="Introduce tus apellidos" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>DNI/NIE</Form.Label>
                                                        <Form.Control disabled={validando} value={dni} onChange={(e) => setDni(e.target.value)} type="text" className="mb-0" id="exampleInputEmail2" placeholder="Introduce tu DNI/NIE" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>  
                                                        <Form.Label>Teléfono</Form.Label>                               
                                                        <Form.Control disabled={validando} value={telefono} onChange={(e) => setTelefono(e.target.value)} type="email" className="mb-0" id="exampleInputEmail3" placeholder="Introduce tu teléfono" autoComplete="off" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group>   
                                                        <Form.Label>Contraseña</Form.Label>                              
                                                        <Form.Control disabled={validando} value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="mb-0" id="exampleInputPassword2" placeholder="Introduce tu contraseña" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="6">
                                                    <Form.Group> 
                                                        <Form.Label>Repetir contraseña</Form.Label>                                
                                                        <Form.Control disabled={validando} value={password2} onChange={(e) => setPassword2(e.target.value)} type="password" className="mb-0" id="exampleInputPassword2" placeholder="Repite tu contraseña" required/>
                                                    </Form.Group>
                                                </Col>
                                                <Col md="12">
                                                    <div className="sign-info">   
                                                        {error && (
                                                        <Message severity="error" text={error} style={{width: 100+'%'}}/>
                                                        )}
                                                    </div>   
                                                </Col>
                                            </Row>

                                            <p>La contraseña escogida tiene que cumplir los siguientes criterios:</p>
                                            <ul>
                                                <li>Debe tener entre 8 y 16 caracteres</li>
                                                <li>Debe contener al menos una letra mayúscula</li>
                                                <li>Debe contener al menos una letra minúscula</li>
                                                <li>Debe contener al menos un número</li>
                                                <li>Debe contener al menos un carácter especial: @-_$#*:.</li>
                                            </ul>
                                            
                                            <Button disabled={validando} onClick={() => validar()} className="btn btn-hover btn-primary1 my-2">{labelBoton}</Button>                              
                                        </Form>
                                    </div>
                                </div>    
                                <div className="mt-3">
                                    <div className="d-flex justify-content-center links">
                                        ¿Ya estás registrado? 
                                        <Link to="/login" className="text-primary ml-2">Ir al login</Link>
                                    </div>                        
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default SignUp;